/**
 * Translations.
 */
export default {
  ACTION: {},
  ERROR: {
    FETCH_ATTACHMENTS: 'Obter anexos'
  },
  HEADER: {
    DATE: 'Data',
    SENT_BY_F: 'Enviada por',
    TITLE: 'Título'
  },
  LABEL: {
    ATTACHMENTS: 'Anexos',
    DATE: 'Data',
    DETAIL: 'Detalhe',
    MESSAGE: 'Mensagem',
    NO_ROWS_COMMUNICATIONS: 'Sem comunicações',
    SENT_BY_F: 'Enviada por',
    TITLE: 'Título',
    UNREAD: 'Não lidas'
  },
  SENTENCE: {},
  SUCCESS: {},
  TOOLTIP: {}
};
